import { render, staticRenderFns } from "./LoginRouter.vue?vue&type=template&id=02aeb655&scoped=true&"
import script from "./LoginRouter.vue?vue&type=script&lang=js&"
export * from "./LoginRouter.vue?vue&type=script&lang=js&"
import style0 from "./LoginRouter.vue?vue&type=style&index=0&id=02aeb655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aeb655",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
